{
  "version": "1.2.6",
  "objects": {
    "7430095584133545113": {
      "type": "frame",
      "id": "7430095584133545113",
      "z": 7333,
      "textContent": "",
      "left": -65.58922487967038,
      "top": 2280.9923359004965,
      "width": 400,
      "height": 500,
      "scaleX": 1.5142588638217511,
      "scaleY": 0.16,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": null,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584134033255": {
      "type": "shape",
      "id": "7430095584134033255",
      "z": 118,
      "shapeName": "icon",
      "textContent": "",
      "left": 224.6849622036198,
      "top": 2309.4036665507138,
      "width": 100,
      "height": 114.28571428571429,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.2115517136212015,
      "scaleY": 0.2115517136212015,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7430095584133545113",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/minus",
      "locked": false
    },
    "7430095584136085558": {
      "type": "wireframe",
      "id": "7430095584136085558",
      "z": 119,
      "top": 2301.4923359004965,
      "left": 276.1143206490301,
      "width": 240,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430095584133545113",
      "layoutPosition": "a3",
      "wireframeName": "datePicker",
      "fill": "#CACACA",
      "itemsData": {
        "7427497414596302796": {
          "id": "7427497414596302796",
          "value": "Item",
          "item_position": 2000000
        },
        "7427497414597361860": {
          "id": "7427497414597361860",
          "value": "Item",
          "item_position": 1000000
        },
        "7427497414602783165": {
          "id": "7427497414602783165",
          "value": "Item",
          "item_position": 0
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "End date", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "End date",
        "iconRight": { "prefix": "fas", "iconName": "calendar-days" }
      }
    },
    "7430095584136025038": {
      "type": "wireframe",
      "id": "7430095584136025038",
      "z": 120,
      "top": 2301.4923359004965,
      "left": -45.58922487967038,
      "width": 240,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430095584133545113",
      "layoutPosition": "a0V",
      "wireframeName": "datePicker",
      "fill": "#CACACA",
      "itemsData": {
        "7427497414596302796": {
          "id": "7427497414596302796",
          "value": "Item",
          "item_position": 2000000
        },
        "7427497414597361860": {
          "id": "7427497414597361860",
          "value": "Item",
          "item_position": 1000000
        },
        "7427497414602783165": {
          "id": "7427497414602783165",
          "value": "Item",
          "item_position": 0
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Start date", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Start date",
        "iconRight": { "prefix": "fas", "iconName": "calendar-days" }
      }
    }
  }
}
